import { Flex, Heading, Text } from '@chakra-ui/react';
import { memo } from 'react';

import CheckListCard from '@features/home/CheckListCard';

const Welcome = () => {
  return (
    <Flex flexDir="column" gap={4} maxW="3xl" h="100%">
      <Heading>Welcome 👋</Heading>
      <Text>Follow these instructions to finalize your vending business setup.</Text>
      <CheckListCard />
    </Flex>
  );
};

export default memo(Welcome);
